import { render, staticRenderFns } from "./PaymentConfirmationList.vue?vue&type=template&id=060a568a&scoped=true&"
import script from "./PaymentConfirmationList.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a568a",
  null
  
)

export default component.exports